import { Navigate, useParams } from 'react-router-dom';

type RedirectType = {
  to: string;
};

export const Redirect = ({ to }: RedirectType) => {
  const { id } = useParams();

  return <Navigate to={`${to}/${id}`} replace />;
};
